export default {"src":"/_next/static/media/errorbg.5bc0667c.svg","height":1214,"width":1985,"blurWidth":0,"blurHeight":0};